var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReputationDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8701 22.2134V5.13345C23.8701 2.71055 18.9305 0.736328 12.843 0.736328C6.7556 0.736328 1.81592 2.70307 1.81592 5.13345V22.2134C1.81592 24.6363 6.7556 26.6105 12.843 26.6105C18.9305 26.6105 23.8701 24.6438 23.8701 22.2134Z",
    fill: "#00E2BC",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.8701 10.8242C23.8701 13.2471 18.9305 15.2213 12.843 15.2213C6.7556 15.2213 1.81592 13.2546 1.81592 10.8242",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8701 5.08887C23.8701 7.51177 18.9305 9.48599 12.843 9.48599C6.7556 9.48599 1.81592 7.51925 1.81592 5.08887",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8701 16.5225C23.8701 18.9454 18.9305 20.9196 12.843 20.9196C6.7556 20.9196 1.81592 18.9528 1.81592 16.5225",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4866 28.7191C28.6417 26.7299 30.2326 23.1404 30.6103 22.1309C30.6757 21.9589 30.7047 21.7869 30.7047 21.5999V16.0662C30.7047 15.4829 30.3706 14.9519 29.8548 14.7126L24.4575 12.2149C24.0798 12.0429 23.6512 12.0429 23.2807 12.2149L17.8834 14.7126C17.3676 14.9519 17.0334 15.4829 17.0334 16.0662V21.5999C17.0334 21.7794 17.0625 21.9589 17.1279 22.1309C17.5056 23.1404 19.1038 26.7299 23.2516 28.7191C23.6439 28.906 24.0943 28.906 24.4866 28.7191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.4866 28.7191C28.6417 26.7299 30.2326 23.1404 30.6103 22.1309C30.6757 21.9589 30.7047 21.7869 30.7047 21.5999V16.0662C30.7047 15.4829 30.3706 14.9519 29.8548 14.7126L24.4575 12.2149C24.0798 12.0429 23.6512 12.0429 23.2807 12.2149L17.8834 14.7126C17.3676 14.9519 17.0334 15.4829 17.0334 16.0662V21.5999C17.0334 21.7794 17.0625 21.9589 17.1279 22.1309C17.5056 23.1404 19.1038 26.7299 23.2516 28.7191C23.6439 28.906 24.0943 28.906 24.4866 28.7191Z",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.0359 20.1046L23.1788 22.1685L26.6947 18.2725",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputationDataIcon);
export default __webpack_public_path__ + "static/media/ReputationDataIcon.aec75bc7b6158dc47ff308d960e7e7c6.svg";
export { ForwardRef as ReactComponent };